export const jwt = state => state.jwt;
export const apikey = state => state.apikey;
export const isLogged = state => state.isLogged;
export const userInfo = state => state.account;
export const resetInfo = state => state.resetInfo;
export const registerInfo = state => state.registerInfo;
export const userLanguage = state => state.language;
export const acceptedCookies = state => state.acceptedCookies;
export const secretQuestions = state => state.secretQuestions;
